/** A name, not a URL, so nothing resolves a host while modules evaluate; all but `gateway` share the backend host. */
export type HttpBase =
    // The SpiceDB-gated API, which needs a user token; the default.
    | 'api'
    // Reachable without a token: tenant details, login, signup, accept-invite.
    | 'public'
    // Skips the SpiceDB gate, so the monitoring machine token works on advanced-permissions tenants.
    | 'internal'
    // Scala multipart upload and download routes: auth as `api`, only under `/files` (see `charts/stackrate-lagom`).
    | 'files'
    // The Node gateway, a separate origin in some deployments.
    | 'gateway';
